import React, { useEffect } from "react";
import { motion } from "framer-motion";

const Home = () => {
  useEffect(() => {
    document.title = "Viktoriia Yashkina — Home";
  }, []);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.75, ease: "easeOut" }}
      className="body"
    >
      <div className="containerBody justify-center">
        <div className="flex flex-row gap-6 md:gap-12">
          <div className="row-homepage">
            <h1 className="font-headerFont text-[70px] md:text-[100px] lg:text-[150px] font-extrabold text-right">
              Hi!
            </h1>
          </div>
          <div className="row-homepage text-[14px] lg:text-[16px]">
            <p>I'm Viktoriia.</p>
            <p>Passionate.</p>
            <p>Hardworking.</p>
            <p>Lifelong Learner.</p>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default Home;
